<template>
  <div class="admin-page">
    <div v-if="!isAdmin" class="permission-denied">
      <el-result
        icon="warning"
        title="权限不足"
        sub-title="您需要管理员权限才能访问此页面"
      >
        <template #extra>
          <el-button type="primary" @click="$router.push('/knowledge/courses')">
            返回课程页面
          </el-button>
        </template>
      </el-result>
    </div>
    <KnowledgeResourceAdmin v-else />
  </div>
</template>

<script>
import KnowledgeResourceAdmin from './components/KnowledgeResourceAdmin.vue'
import { isSystemAdmin } from '@/utils/sysRole'

export default {
  name: 'KnowledgeResourceAdminView',
  components: {
    KnowledgeResourceAdmin
  },
  data() {
    return {
      isAdmin: false
    }
  },
  created() {
    this.checkAdminPermission()
  },
  methods: {
    checkAdminPermission() {
      const userInfo = localStorage.getItem('user_info')
      if (userInfo) {
        const user = JSON.parse(userInfo)
        this.isAdmin = isSystemAdmin(user.sysRole)
      }
    }
  }
}
</script>
